import React, { Component } from 'react';
import { Redirect, withRouter, Link } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import authService from '../../services/AuthService';
import GeneralProfile from './GeneralProfile';
import AccountProfile from './AccountProfile';
import LegalProfile from './LegalProfile';
import PaymentProfile from './PaymentProfile';

import './Profile.css';

const logoPath = "/content/CorbettLogo.png";

class Profile extends Component {

    render() {
        // Ensure user is authenticated or boot them to login page
        if (!authService.isAuthenticated) {
            return (<Redirect to='/' />);
        }

        let userId = authService.authenticatedUserId;
        let userName = authService.authenticatedUserName;
        let isClinician = authService.isClearClinician;

console.log("User Info:", {
    userId,
    userName,
    isClinician,
    displayName: this.props.location && this.props.location.state && this.props.location.state.userDisplayName,
    tabToDisplay: this.props.location && this.props.location.state && this.props.location.state.tabToDisplay
});


        return (
            <Container>
                <Link to="/home"><img src={logoPath} className="profile_cadeLogo" width="50" height="auto" className="home_cadeLogo tour_homeCadeLogo" alt="CADE Header" /></Link>
                <p className="profile_autoSave">Changes will be auto-saved</p>
                <h2>{this.props.location.state.userDisplayName} Profile <span className="profile_cadeId">CADE ID: {userId}</span></h2>
               
                <Tabs defaultActiveKey={this.props.location.state.tabToDisplay} id="profileTabs">
                    <Tab eventKey="generalTab" title="Profile">
                        <GeneralProfile
                            userId={userId}
                        />
                    </Tab>
                    <Tab eventKey="accountTab" title="Account Information">
                        <AccountProfile
                            userId={userId}
                            userName={userName}
                        />
                    </Tab>
                    <Tab eventKey="legalTab" title="Legal Information">
                        <LegalProfile
                            userId={userId}
                            userName={userName}
                        />
                    </Tab>
                    <Tab eventKey="paymentTab" title="Payment Information">
                        <PaymentProfile
                            userId={userId}
                        />
                    </Tab>
                </Tabs>
            </Container>
        )
    }
}

export default withRouter(Profile);


// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js